import { createFileRoute } from "@tanstack/react-router"
import { Signup } from "modules/auth/components/Signup"

export const Route = createFileRoute("/_base/_public/signup")({
  component: Signup,
})
